<app-title-pages-component
  [pageData]="pageData"
  [showClientName]="true"
></app-title-pages-component>

@if(showForm){
  <div class="container">
    <form [formGroup]="formDepartament" (ngSubmit)="handleSubmit()">
      <!-- Razón social -->
      <div class="form-row">
        <div class="input-container span-3">
          <input id="name" type="text" class="form-control" formControlName="name" required
                 [ngClass]="{ 'filled': formDepartament.get('name')?.value}"/>
          <label for="name">Nombre del departamento*</label>

          @if (submitted && name?.invalid && (!name?.untouched || name?.dirty || formDepartament)) {
            <div class="alert alert-danger">
              @if (name?.hasError('required') || name?.hasError('soloEspacios')) {
                <span>
                El nombre del departamento es requiredo y no puede estar vacío.
              </span>
              }
            </div>
          }
        </div>

      </div>

      <div class="form-row-2">
        <button type="button" (click)="handleCancelAdd()">Cancelar</button>
        <button type="submit" >Guardar</button>
      </div>
    </form>
  </div>
}

<app-table-with-inputs-component
  [columns]="columnDefinitions"
  [data]="departaments"
  (addSingle)="handleAddSingle()"
  (addBulk)="handleBulkUpload()"
  [editMode]="showBtn"
  [actionsIcons]="iconActions"
  [labelForSearch]="'Buscar departamento'"
  [nameSeccion]="'departamento'"
  (saveItem)="handleSaveEdit($event)"
  (eliminar)="showConfirmDeleteDialog($event)"
>
</app-table-with-inputs-component>

@if(showModal){
  <app-confirm-delete-dialog
    [message]="message"
    (confirmar)="handleDelete()"
    (cancelar)="handleCancelDeleteDialog()"
  ></app-confirm-delete-dialog>
}

@if (showBulkUploadModal) {
  <app-bulk-upload-modal
    [resourceLabel]="'Departamentos'"
    (downloadFormat)="onDescargarFormato($event)"
    (closeModal)="onBulkClose()"
    (confirm)="onBulkConfirm($event)">
  </app-bulk-upload-modal>
}

@if (showModalPasosCampaign) {
  <app-modal-pasos-campana (cerrar)="closeModalPasosCampaign()"></app-modal-pasos-campana>
}


